dmx.Component('bs5-modal', {

  initialData: {
    visible: false,
  },

  attributes: {
    nobackdrop: {
      type: Boolean,
      default: false
    },

    nocloseonclick: {
      type: Boolean,
      default: false
    },

    nokeyboard: {
      type: Boolean,
      default: false
    },

    nofocus: {
      type: Boolean,
      default: false
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggle () {
      this._instance.toggle();
    },

    show () {
      this._instance.show();
    },

    hide () {
      this._instance.hide();
    },

    update () {
      this._instance.handleUpdate();
    }
  },

  events: {
    show: Event,
    shown: Event,
    hide: Event,
    hidden: Event
  },

  init (node) {
    this._showHandler = this._showHandler.bind(this);
    this._shownHandler = this._shownHandler.bind(this);
    this._hideHandler = this._hideHandler.bind(this);
    this._hiddenHandler = this._hiddenHandler.bind(this);

    node.addEventListener('show.bs.modal', this._showHandler);
    node.addEventListener('shown.bs.modal', this._shownHandler);
    node.addEventListener('hide.bs.modal', this._hideHandler);
    node.addEventListener('hidden.bs.modal', this._hiddenHandler);

    this._instance = new bootstrap.Modal(node, {
      backdrop: !this.props.nobackdrop && this.props.nocloseonclick ? 'static' : !this.props.nobackdrop,
      keyboard: !this.props.nokeyboard,
      focus: !this.props.nofocus,
    });

    if (this.props.show) {
      requestAnimationFrame(() => {
        this.set('visible', true);
        this._instance.show();
      });
    }
  },

  destroy () {
    this.$node.removeEventListener('show.bs.modal', this._showHandler);
    this.$node.removeEventListener('shown.bs.modal', this._shownHandler);
    this.$node.removeEventListener('hide.bs.modal', this._hideHandler);
    this.$node.removeEventListener('hidden.bs.modal', this._hiddenHandler);

    this._instance.dispose();
  },

  performUpdate (updatedProps) {
    if (updatedProps.has('nobackdrop') || updatedProps.has('nocloseonclick') || updatedProps.has('nokeyboard') || updatedProps.has('nofocus')) {
      this._instance.dispose();
      this._instance = new bootstrap.Modal(this.$node, {
        backdrop: !this.props.nobackdrop && this.props.nocloseonclick ? 'static' : !this.props.nobackdrop,
        keyboard: !this.props.nokeyboard,
        focus: !this.props.nofocus,
      });
    }

    if (updatedProps.has('show')) {
      this._instance[this.props.show ? 'show' : 'hide']();
    }
  },

  _showHandler () {
    this.set('visible', true);
    this.dispatchEvent('show');
  },

  _shownHandler () {
    this.dispatchEvent('shown');
  },

  _hideHandler () {
    this.dispatchEvent('hide');
  },

  _hiddenHandler () {
    this.set('visible', false);
    this.dispatchEvent('hidden');
  },

});
